import { Participant } from '@rolebase/shared/model/member'

// Who to propose as the person bringing a tension, from the holders of the
// role picked in the meeting form (`orgData.getLeaders`: a circle's link roles
// if it has any, otherwise the role's own holders).
//
// Exactly one person → them. None, or several → nobody: the facilitator asks
// out loud (Yohan, 21/09/2026, #108). Falling back to the person at the
// keyboard is what used to file tensions under the wrong name.
export function proposedInitiator(
  leaders: readonly Participant[]
): string | undefined {
  const ids = new Set(leaders.map((leader) => leader.member.id))
  return ids.size === 1 ? ids.values().next().value : undefined
}
